'use strict';

const init = () => {
    const servicesList = document.querySelector('.tc-website-serviceslist');
    if (servicesList && document.body.classList.contains('touch')) {
        servicesList.querySelectorAll('.tc-website-serviceslistitem > a').forEach((item) => {
            item.addEventListener('click', (event) => {
                if (!item.classList.contains('show')) {
                    event.preventDefault();
                    event.stopPropagation();
                    item.classList.add('show');
                }

                servicesList.querySelectorAll('.tc-website-serviceslistitem > a.show').forEach((link) => {
                    if (link !== item) {
                        link.classList.remove('show');
                    }
                });
            });
        });
    }
}

export default {init};
